import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import { getFiltersInfo } from '../../common/utils/FiltersInfo';
import GlobalMonthRangePicker from '../../common/components/GlobalMonthPicker/GlobalMonthPicker';

export const currentYear = parseInt(moment().format('YYYY'));
export const currentMonth = parseInt(moment().format('M'));
const TargetMonthFilter = ({
  setChangeMonth,
  changeMonth,
  placeholder = 'Target Month',
  targetMonthRange = false,
  dontShowCachingData = false
}) => {
  const [validRange, setValidRange] = useState(
    targetMonthRange
      ? targetMonthRange
      : {
          min: { year: 1990, month: 1, date: 28 },
          max: {
            year: currentYear + 10,
            month:
              moment()
                .subtract(1, 'months')
                .month() + 1,
            date: 28
          }
        }
  );
  const [rangeValue, setRangeValue] = useState(
    typeof getFiltersInfo == 'function' && getFiltersInfo()?.targetMonth
      ? getFiltersInfo()?.targetMonth
      : {
          year: currentYear,
          month: currentMonth,
          date: 28
        }
  );

  useEffect(() => {
    if (dontShowCachingData) return;
    let targetMonth = getFiltersInfo()?.targetMonth;
    if (typeof getFiltersInfo == 'function') {
      setChangeMonth(targetMonth);
    }
  }, []);
  return (
    <div>
      <div
        className="relative leading-relaxed w-56 bg-white h-10 flex flex-row justify-around content-center rounded mt-2 xxl:mt-0"
        style={{ border: '1px solid #f0dbdb' }}
      >
        <GlobalMonthRangePicker
          singlePicker
          removeDropDown
          onChangeSinglePicker={e => setChangeMonth(e)}
          styleObject={{
            height: '40px',
            backgroundColor: 'transparent',
            border: 'none',
            marginTop: '0px',
            marginBottom: '0px'
          }}
          rangeValue={{ ...rangeValue }}
          setRangeValue={setRangeValue}
          validRange={{ ...validRange }} //{min: 2013}//[2013, 2015, 2016]//5// {max: 2015}
          placeHolder={
            changeMonth?.year
              ? moment(`${changeMonth.year}-${changeMonth.month}-28`).format(
                  'MMM YYYY'
                )
              : placeholder
          }
        />
        <div
          className="modal-close cursor-pointer self-center mx-auto"
          onClick={e => {
            setChangeMonth(null);
            setRangeValue({
              year: currentYear,
              month: currentMonth,
              date: 28
            });
          }}
        >
          <svg
            className="fill-current text-black"
            xmlns="http://www.w3.org/2000/svg"
            width={18}
            height={18}
            viewBox="0 0 18 18"
          >
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
          </svg>
        </div>
      </div>
    </div>
  );
};
export default TargetMonthFilter;
